import * as React from "react";
const SvgLokalise = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 489 489",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M355.648 0H133.352C59.7036 0 0 59.7036 0 133.352V355.648C0 429.296 59.7036 489 133.352 489H355.648C429.296 489 489 429.296 489 355.648V133.352C489 59.7036 429.296 0 355.648 0Z",
  fill: "#FCB9B0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.309 295.169H336.318H303.151H294.926L244.988 345.107L194.997 295.169H186.825H153.605H103.667V345.107H174.327L209.631 380.464L244.988 415.767L280.292 380.464L315.648 345.107H386.309V295.169Z",
  fill: "#131E29"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.309 195.24H103.667V245.178H386.309V195.24Z",
  fill: "#131E29"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.309 95.3113H103.667V145.249H386.309V95.3113Z",
  fill: "#131E29"
}));
export default SvgLokalise;
//# sourceMappingURL=Lokalise.js.map